import React from 'react'

const noop = () => {
  console.warn('Attempted to open a modal without a ModalProvider')
  return Promise.resolve<any>(null)
}
export type ModalCallback = (resolve: (val?: any) => any) => React.ReactElement

export type ModalContextType = <T = void>(modal: React.ReactNode | ModalCallback) => Promise<T>
const ModalContext = React.createContext<ModalContextType>(noop)

export default ModalContext
